import React, { useRef, useState } from 'react'
import './styles.css'
import { handleFotoPerfilUpload as uploadFotoPerfil, handleUserName } from './functions';

import { Input } from '../Input'
import { Erro } from '../../pages/Cliente/AlteracaoSenha/AlteracaoSenha';
import SegurancaDeSenha from '../SegurancaSenha/SegurancaSenha';

interface CadastroAcessoProps {
    userName: string,
    setUserName: React.Dispatch<React.SetStateAction<string>>,
    setEmail: React.Dispatch<React.SetStateAction<string>>,
    setPassword: React.Dispatch<React.SetStateAction<string>>,
    setImagePerfil: React.Dispatch<React.SetStateAction<string | ArrayBuffer | null>>,
    setSenhaConfirmada: React.Dispatch<React.SetStateAction<string>>,
    senha: string,
    setError: React.Dispatch<React.SetStateAction<Erro>>,
}

const CadastroAcesso = ({ userName, setUserName, setEmail, setPassword, setImagePerfil, setSenhaConfirmada, senha, setError }: CadastroAcessoProps) => {
    const filesElement = useRef<HTMLInputElement | null>(null);
    const [selectedFileName, setSelectedFileName] = useState<string | null>(null);
    const [senhasVisiveis, setSenhasVisiveis] = useState(false);

    const handleFotoPerfilUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files ? e.target.files[0] : null;
        if (file) {
            setSelectedFileName(file.name);
            uploadFotoPerfil(e, setError, setImagePerfil);
        }
    };

    const handleFileClick = () => {
        if (filesElement.current) {
            filesElement.current.click();
        }
    };

    return (
        <div className="AreaLogin">
            <fieldset className="fieldsetCadastro">
                <div className="inputsCadastroAcesso">
                    <div className="campoCadastro">
                        <Input required label="Usuário" placeholder=' ' value={userName}
                            autoComplete="username"
                            onChange={(e) => handleUserName(e.target.value, setError, setUserName)} />
                    </div>

                    <div className="campoCadastro">
                        <Input required type="email" label="E-mail" placeholder=' '
                            autoComplete="email"
                            onChange={(e) => setEmail(e.target.value)} />
                    </div>

                    <div className="campoCadastro">
                        <Input required type="password" label="Senha" placeholder=' ' senha
                            autoComplete="new-password"
                            senhaVisivel={senhasVisiveis}
                            onAlternarVisibilidadeSenha={() => setSenhasVisiveis((visiveis) => !visiveis)}
                            onChange={(e) => setPassword(e.target.value)} />
                    </div>

                    <SegurancaDeSenha senha={senha} />

                    <div className="campoCadastro">
                        <Input required type="password" label="Confirme a Senha" placeholder=' ' senha
                            autoComplete="new-password"
                            senhaVisivel={senhasVisiveis}
                            onAlternarVisibilidadeSenha={() => setSenhasVisiveis((visiveis) => !visiveis)}
                            onChange={(e) => setSenhaConfirmada(e.target.value)} />
                    </div>
                </div>

                <div className="Area_DocumentosAnexos">
                    <label className="DocumentosAnexos">Foto de perfil</label>
                    <div className="file-upload-wrapper">
                        <button
                            className="DocumentosAnexos_Botao"
                            type="button"
                            onClick={handleFileClick}
                        >
                            Selecionar Arquivo
                        </button>

                        {/* Input de tipo file escondido */}
                        <input
                            ref={filesElement}
                            type="file"
                            style={{ display: 'none' }}
                            onChange={handleFotoPerfilUpload}
                            accept="image/*"
                        />

                        {selectedFileName && <div className="file-name">{selectedFileName}</div>}
                    </div>
                </div>
            </fieldset>
        </div>
    );
};

export default CadastroAcesso;
